<template>
  <div class="panel-container">
    <!-- 主体容器 -->
    <div class="main-container">
      <section class="hist-card">
        <!-- header：标题 + 筛选 + 导出（强制一行） -->
        <div class="hist-card__header">
          <div class="title-container">
            <span class="symbol-icon"></span>
            <span class="title-text">{{ $str.getKey('收益管理/各省尖峰平谷历史电价') }}</span>
          </div>

          <div class="btns-container">
            <div class="filters-scroll">
              <el-form class="filter-form" label-position="left" :model="formData">
                <el-form-item class="query-item query-item--area" :label="$str.getKey('收益管理/地区')">
                  <el-cascader class="field-wide" v-model="formData.adCode" :options="adOptions" @change="handleAdChange" :props="formData.cascaderProps" :show-all-levels="false" clearable />
                </el-form-item>
                <el-form-item class="query-item query-item--date" :label="$str.getKey('收益管理/日期')">
                  <el-date-picker class="field-date" v-model="formData.month"  type="month" :clearable="true" :placeholder="$str.getKey('收益管理/请选择')" @change="timeRangeChange" :disabled-date="disabledDate"></el-date-picker>
                </el-form-item>
                <el-form-item class="query-item" :label="$str.getKey('收益管理/工业类型')">
                  <el-select class="field-narrow" v-model="formData.industryType" :placeholder="$str.getKey('收益管理/请选择')" clearable @change="handleIndustryChange">
                    <el-option v-for="item in industryTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="query-item" :label="$str.getKey('收益管理/制度')">
                  <el-select class="field-narrow" v-model="formData.systemType" :placeholder="$str.getKey('收益管理/请选择')" clearable @change="handleSystemChange">
                    <el-option v-for="item in systemTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="query-item" :label="$str.getKey('收益管理/类型')">
                  <el-select class="field-narrow" v-model="formData.priceType" :placeholder="$str.getKey('收益管理/请选择')" clearable @change="handlePriceTypeChange">
                    <el-option v-for="item in priceTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="query-item" :label="$str.getKey('收益管理/电压等级')">
                  <el-select class="field-narrow" v-model="formData.voltageLevel" :placeholder="$str.getKey('收益管理/请选择')" clearable @change="handleVolLevelChange">
                    <el-option v-for="item in voltageLevelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>

            <div class="actions">
              <el-button class="meter-feature-btn meter-feature-btn--lg" type="primary" @click="handleExport">{{ $str.getKey('收益管理/导出') }}</el-button>
            </div>
          </div>
        </div>
        
        <!-- body：表格 + 分页 -->
        <div class="hist-card__body">
          <div class="table-container">
            <div class="spot-table-wrap" v-loading="loading">
              <div class="spot-table-inner">
                <v-table
                  density="compact"
                  class="bg-transparent flex-grow-1 gm-table ops-table ops-spot-table"
                  style="width: 100%"
                >
                  <thead>
                    <tr>
                      <th>{{ $str.getKey('收益管理/地区') }}</th>
                      <th>{{ $str.getKey('收益管理/日期') }}</th>
                      <th>{{ $str.getKey('收益管理/工业类型') }}</th>
                      <th>{{ $str.getKey('收益管理/制度') }}</th>
                      <th>{{ $str.getKey('收益管理/电压等级') }}</th>
                      <th class="text-end">{{ $str.getKey('收益管理/尖锋时段(元)') }}</th>
                      <th class="text-end">{{ $str.getKey('收益管理/高峰时段(元)') }}</th>
                      <th class="text-end">{{ $str.getKey('收益管理/平时段(元)') }}</th>
                      <th class="text-end">{{ $str.getKey('收益管理/低谷时段(元)') }}</th>
                      <th class="text-end">{{ $str.getKey('收益管理/深谷时段(元)') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, idx) in tableData" :key="String(row.id || '') + '-' + idx">
                      <td class="cell-text">{{ row.adName }}</td>
                      <td class="cell-text">{{ row.month }}</td>
                      <td class="cell-text">{{ row.industryLabel }}</td>
                      <td class="cell-text">{{ row.systemLabel }}</td>
                      <td class="cell-text">{{ row.voltageLevel }}</td>
                      <td class="text-end"><span class="cell-text">{{ row?.segmentInfo?.sharpPrice ?? '-' }}</span></td>
                      <td class="text-end"><span class="cell-text">{{ row?.segmentInfo?.peakPrice ?? '-' }}</span></td>
                      <td class="text-end"><span class="cell-text">{{ row?.segmentInfo?.flatPrice ?? '-' }}</span></td>
                      <td class="text-end"><span class="cell-text">{{ row?.segmentInfo?.valleyPrice ?? '-' }}</span></td>
                      <td class="text-end"><span class="cell-text">{{ row?.segmentInfo?.deepValleyPrice ?? '-' }}</span></td>
                    </tr>
                    <tr v-if="(tableData || []).length === 0 && !loading">
                      <td class="empty-cell" colspan="10">暂无数据（请调整筛选条件）</td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
            </div>
          </div>

          <TablePagination
            v-model="pageCtrl.currentPage"
            v-model:page-size="pageCtrl.pageSize"
            :total="pageCtrl.total"
            :disabled="loading"
            @change="handlePageChange"
          />
        </div>
      </section>

    </div>

  </div>
</template>

<script setup>
import { ref, reactive, computed, nextTick } from "vue"
import dayjs from 'dayjs';
import { queryHistoryList } from './api/index.js';
import { ElMessageBox } from "element-plus";
import { download_get } from "@/api/modules/download/index.js";
import TablePagination from '@/components/TablePagination/index.vue'
import {
  industryLabelFromValue,
  businessPriceTypeNumFromEntryKey,
  industryValueFromFormKey,
  systemLabelFromValue,
  typeValueFromSystemKey,
} from './utils/priceEnum'


const $str = window.$str;

/** 设置组件配置项 */
defineOptions({
  name: "HistoryListPanel"
});

/** 接收父组件信息 */
const props = defineProps({
  adOptions: {
    type: Array,
    default: []
  },
});

defineExpose({ refreshByParent }); // 提供给父组件调用的方法


const loading = ref(false); // 控制加载中动效的渲染
const adOptions = computed(() => props.adOptions);
const voltageLevelList = ref([
  {
    label: '1kv',
    value: '1kv',
  },
  {
    label: '10kv',
    value: '10kv',
  },
  {
    label: '20kv',
    value: '20kv',
  },
  {
    label: '35kv',
    value: '35kv',
  },
  {
    label: '110kv',
    value: '110kv',
  },
  {
    label: '220kv',
    value: '220kv',
  },
])
const tableData = ref([]); // 列表数据
const industryTypeList = ref([
  { label: $str.getKey('收益管理/一般工商业'), value: 'generalBusiness' },
  { label: $str.getKey('收益管理/大工业'), value: 'bigIndustry' },
])
const systemTypeList = ref([
  { label: $str.getKey('收益管理/两部制'), value: 'twoPart' },
  { label: $str.getKey('收益管理/单一制'), value: 'single' },
])
const priceTypeList = ref([
  { label: $str.getKey('收益管理/代理购电'), value: 'proxy' },
  { label: $str.getKey('收益管理/充电桩电价'), value: 'chargePile' },
])
// 页码控制器
const pageCtrl = reactive({ // 页码控制器
  total: 0,
  currentPage: 1,
  pageSize: 10,
  pageSizes: [10, 20, 50]
});


// 表单对应的数据对象
const formData = reactive({
  cascaderProps: { // 级联配置对象
    checkStrictly: true,
    expandTrigger: 'hover',
    emitPath: false, // 只返回当前节点的值
  },
  adCode: '', // 示例：山东省-370000
  // month: dayjs().format('YYYY-MM'),
  month: null,
  industryType: '',
  systemType: '',
  priceType: '',
  voltageLevel: '',
})

initPanel();



/** ====== [业务：功能方法] =================================================================== */
/** 初始化面板 */
function initPanel() {
  refreshHistoryList();
}

/** 设置日期的禁选范围 */
function disabledDate(date) {
  return false;
  // return date < dayjs().subtract(6, 'month').startOf('month');
  // return date > dayjs() || date < dayjs().subtract(6, 'month').startOf('month');
}

/** 事件响应：行政区域发生变化 */
function handleAdChange(adCode) {
  formData.adCode = adCode;
  refreshHistoryList();
}

/** 响应选择月份发生变化 */
function timeRangeChange(value) {
  refreshHistoryList();
}

function handleVolLevelChange(value) {
  refreshHistoryList();
}

function handleIndustryChange() {
  pageCtrl.currentPage = 1
  refreshHistoryList()
}

function handleSystemChange() {
  pageCtrl.currentPage = 1
  refreshHistoryList()
}

function handlePriceTypeChange() {
  pageCtrl.currentPage = 1
  refreshHistoryList()
}

// 展示/筛选映射统一收敛到 `utils/priceEnum.js`
/** 事件响应：页码发生变化 */
function handlePageChange(pageNum) {
  pageCtrl.currentPage = pageNum;
  refreshHistoryList();
}



/** ====== [辅助：功能方法] =================================================================== */
/** 刷新表格数据 */
function refreshHistoryList() {
  const params = {
    // type: 0,
    pageSize: pageCtrl.pageSize,
    pageNum: pageCtrl.currentPage,
  }
  if (formData.adCode) {
    params['areaCode'] = formData.adCode;
  }
  if (formData.month) {
    params['monthValue'] = dayjs(formData.month).format('YYYY-MM');
  }
  // 按后端字段定义筛选：industry(0/1) + type(0/1)
  const industryVal = industryValueFromFormKey(formData.industryType)
  if (industryVal !== undefined) params.industry = industryVal
  const typeVal = typeValueFromSystemKey(formData.systemType)
  if (typeVal !== undefined) params.type = typeVal
  // 电价类型：后端约定数字 1 / 2 / 3（勿传 proxy 字符串）
  if (formData.priceType) {
    const pt = businessPriceTypeNumFromEntryKey(formData.priceType)
    if (pt !== undefined) params.priceType = pt
  }
  if (formData.voltageLevel) {
    params['voltageLevel'] = formData.voltageLevel;
  }

  loading.value = true;
  queryHistoryList(params).then(res => {
    if (res?.data) {
      pageCtrl.total = res.data.total;
      if (Array.isArray(res.data.rows)) {
        tableData.value = res.data.rows.map(row => {
          const rawIndustry = row.industryType ?? row.industry
          const itme = {
            adName: row.areaName, // 地区名称
            adCode: row.areaCode, // 地区行政编码
            month: dayjs(row.monthDate).format('YYYY-MM'), // 电价对应的月份
            industryLabel: industryLabelFromValue(rawIndustry),
            systemLabel: systemLabelFromValue(row.systemType ?? row.type),
            voltageLevel: row.voltageLevel, // 电压等级 1kv，10kv，20kv，35kv，110kv, 220kv
            segmentInfo: {
              sharpPrice: row.sharpPrice, // 尖峰
              peakPrice: row.peakPrice, // 高峰
              flatPrice: row.flatPrice, // 平
              valleyPrice: row.valleyPrice, // 低谷
              deepValleyPrice: row.deepPrice, // 深谷
            },
          }
          return itme;
        })
      }
    }
  }).finally(() => {
    loading.value = false;
  });
}


/** 提供给外部的方法：刷新当前面板数据 */
function refreshByParent(info) {
  let needRefresh = true;
  if (formData.adCode && formData.adCode !== info.adCode) {
    needRefresh = false;
  }
  if (formData.month && formData.month !== info.month) {
    needRefresh = false;
  }

  if(needRefresh) {
    pageCtrl.currentPage = 1;
    refreshHistoryList();
  }
}

/** 导出收益明细表格数据 */
function handleExport() {
  ElMessageBox.confirm($str.getKey('收益管理/是否确认导出所有数据项？'), $str.getKey('收益管理/提示'), {
    confirmButtonText: $str.getKey('收益管理/确定'),
    cancelButtonText: $str.getKey('收益管理/取消'),
    type: 'warning',
  }).then(() => {
    // 与 refreshHistoryList 一致：industry 见 priceEnum；type 为单一制/两部制（非工业类型）
    const params = {}

    if (formData.adCode) {
      params.areaCode = formData.adCode; // 行政代码
    }
    if (formData.voltageLevel) {
      params.voltageLevel = formData.voltageLevel; // 1kv，10kv，20kv，35kv，110kv, 220kv
    }
    if (formData.month) {
      params.monthValue = dayjs(formData.month).format('YYYY-MM'); // 月份
    }
    const industryVal = industryValueFromFormKey(formData.industryType)
    if (industryVal !== undefined) params.industry = industryVal
    const typeVal = typeValueFromSystemKey(formData.systemType)
    if (typeVal !== undefined) params.type = typeVal
    if (formData.priceType) {
      const pt = businessPriceTypeNumFromEntryKey(formData.priceType)
      if (pt !== undefined) params.priceType = pt
    }

    download_get(
      "/dashboard/state/grid/price/list/export",
      params,
      `elec_price_history_${new Date().getTime()}.xlsx`
    );
  })
}


</script>
<style lang="scss" scoped>
@import '../_shared/feature-button.scss';

.panel-container {
  & {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    height: 100%;
    background: transparent;
    padding: 0;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  .main-container {
    & {
      width: 100%;
      max-width: 100%;
      height: 100%;
      min-width: 0;
      overflow: hidden;
      padding: 0;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
    }

    > * {
      min-width: 0;
      max-width: 100%;
      box-sizing: border-box;
    }

    .hist-card {
      border-radius: 20px;
      background: rgba(255, 255, 255, 0.82);
      border: 1px solid rgba(0, 0, 0, 0.06);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
      overflow: hidden;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }

    .hist-card__header {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: stretch;
      gap: 14px;
      padding: 12px 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      background: linear-gradient(180deg, rgba(58, 104, 255, 0.05) 0%, rgba(255, 255, 255, 0) 72%);
      min-height: 56px;
      box-sizing: border-box;
      overflow-x: hidden;
    }

    .hist-card__header .title-container {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
      min-width: 0;
      flex: 0 0 auto;
    }

    .hist-card__header .symbol-icon {
      width: 4px;
      height: 20px;
      background: #485e91;
      border-radius: 2px;
    }

    .hist-card__header .title-text {
      font-size: 16px;
      font-weight: 600;
      color: rgba(46, 46, 46, 0.88);
      white-space: nowrap;
    }

    .hist-card__header .btns-container {
      width: 100%;
      flex: 0 0 auto;
      min-width: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 100%;
      overflow-x: hidden;
      gap: 12px;
      flex-wrap: nowrap;
    }

    .filters-scroll {
      flex: 1 1 auto;
      min-width: 0;
      max-width: 100%;
      overflow: hidden;
    }

    .filters-scroll::-webkit-scrollbar {
      height: 4px;
    }
    .filters-scroll::-webkit-scrollbar-thumb {
      background: rgba(15, 23, 42, 0.12);
      border-radius: 999px;
    }
    .filters-scroll::-webkit-scrollbar-track {
      background: transparent;
    }

    .filter-form {
      display: grid;
      grid-template-columns: repeat(4, minmax(220px, 1fr));
      column-gap: 12px;
      row-gap: 10px;
      align-items: center;
      width: 100%;
      min-width: 100%;
      max-width: 100%;
      margin-left: 0;
    }

    .filter-form :deep(.el-form-item) {
      margin: 0;
      min-width: 0;
    }

.query-item--area {
  width: auto;
}

.query-item--date {
  width: auto;
}

    .filter-form :deep(.el-form-item__label) {
      font-size: 16px;
      color: rgba(46, 46, 46, 0.65);
      line-height: 1.3;
      padding: 0;
      padding-right: 8px;
      white-space: nowrap;
    }

    /* label 在左侧：固定标签宽度，整体更像 PC 表单 */
    .filter-form :deep(.el-form-item__label) {
      width: 60px;
      justify-content: flex-end;
      line-height: 40px;
    }

    .filter-form :deep(.el-form-item) {
      display: flex;
      align-items: center;
      min-height: 40px;
    }

    .filter-form :deep(.el-form-item__content) {
      line-height: 40px;
      display: flex;
      align-items: center;
      min-height: 40px;
      margin: 0 !important;
    }

    .filter-form :deep(.el-date-editor),
    .filter-form :deep(.el-cascader),
    .filter-form :deep(.el-select),
    .filter-form :deep(.el-input) {
      width: 100%;
      min-width: 0;
    }

    .filter-form :deep(.el-input__wrapper),
    .filter-form :deep(.el-select__wrapper),
    .filter-form :deep(.el-date-editor .el-input__wrapper),
    .filter-form :deep(.el-cascader .el-input__wrapper) {
      /* 对齐电价维护头部筛选（MeterData 风格） */
      background: #fff;
      border: 1px solid rgba(192, 207, 218, 0.3);
      border-radius: 20px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
      padding: 0 16px;
      min-height: 40px;
      height: 40px;
      align-items: center;
    }

    /* 字段宽度规范（参照现货电价筛选区） */
    .filter-form :deep(.field-wide) {
      width: 100%;
    }

    .filter-form :deep(.field-date) {
      width: 100%;
    }

    .filter-form :deep(.field-narrow) {
      width: 100%;
    }

    .query-item--area :deep(.el-cascader) {
      width: 100% !important;
    }

    .query-item--date {
      display: flex;
      align-items: center;
    }

    .query-item--date :deep(.el-date-editor) {
      width: 100% !important;
      height: 40px !important;
      display: inline-flex;
      align-items: center;
    }

    /* 修复日期筛选项视觉偏下，与同排筛选项拉齐 */
    .query-item--date :deep(.el-form-item__content) {
      display: flex;
      align-items: center;
      margin-top: 0 !important;
      min-height: 40px;
      transform: none;
    }

    .query-item--date :deep(.el-date-editor),
    .query-item--date :deep(.el-input__wrapper) {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

    .query-item--date :deep(.el-date-editor .el-input__wrapper) {
      height: 40px !important;
      min-height: 40px !important;
      line-height: 40px !important;
    }

    .query-item--date :deep(.el-input__inner) {
      width: 100%;
      text-align: left;
    }

    .actions {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: auto;
      padding-bottom: 0;
    }

    .actions :deep(.el-button) {
  white-space: nowrap;
    }

    .hist-card__body {
      padding: 14px 16px 16px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      min-height: 0;
    }

    .table-container {
      width: 100%;
      min-height: 520px;
      display: grid;
      grid-template-rows: 1fr;
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid rgba(0, 0, 0, 0.06);
      background: rgba(255, 255, 255, 0.78);
      box-shadow: none;
    }

    .spot-table-wrap {
      width: 100%;
      min-height: 520px;
      display: flex;
      overflow: visible;
    }

    .spot-table-inner {
      width: 100%;
      min-width: 0;
      overflow: visible;
    }

    .ops-spot-table {
      width: 100%;
      max-width: 100%;
      min-height: 0;
      background: transparent !important;
    }

    .ops-spot-table :deep(.v-table__wrapper) {
      width: 100%;
      max-width: 100%;
      overflow-x: hidden;
      overflow-y: visible;
      background: transparent !important;
    }

    .ops-spot-table :deep(table) {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      background: transparent;
    }

    .ops-spot-table :deep(thead th),
    .ops-spot-table :deep(tbody td) {
      min-width: 0 !important;
      max-width: 1px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .cell-text {
      color: rgba(46, 46, 46, 0.86);
    }

    .empty-cell {
      text-align: center;
      color: rgba(46, 46, 46, 0.5);
      padding: 18px 0;
    }

  }
   /* 按钮统一白字（本页 UI 规范） */
   :deep(.el-button:not(.is-link)) {
    --el-button-text-color: #fff;
    color: #fff;
  }

}


</style>
